import React, { useEffect, useState } from 'react';
import {
  Card,
  Select,
  Typography
} from 'antd';
import { useFetchPageData, usePageData } from '../../../hooks/usePage';
import { IAppointment } from '../../../interfaces/patient';
import { IPageData } from '../../../interfaces/page';
import jwt_decode from 'jwt-decode';

const pageData: IPageData = {
  fulFilled: false,
  breadcrumbs: [
    {
      title: 'Administración de Permisos',
      route: 'administracion-permisos'
    },
    {
      title: 'Permisos'
    }
  ]
};

const key = 'regitrando';

const AdministracionPermisos = () => {
  const token: any = jwt_decode(localStorage.getItem('token'));
  const usr: any = JSON.parse(token.data);
  usePageData(pageData);
  const [appointments] = useFetchPageData<IAppointment[]>('./data/last-appointments.json', []);
  return (
    <>
      <Card title={'Administración de permisos'}>
      </Card>
    </>
  );
};

export default AdministracionPermisos;